import { createAction } from 'typesafe-actions';
import { Platform } from '../types';

export const userLogin = createAction('user/login')<Platform>();
export const userLogout = createAction('user/logout')();
